import Layout from "../Layout/Layout";

const App = () => {
  return <Layout />;
};

export default App;
